import { defineStyleConfig } from '@chakra-ui/system';

export const NumberInput = defineStyleConfig({
    baseStyle: {
        root: {
            fontFamily: 'TT Norms Pro',
        },
        field: {
            fontFamily: 'TT Norms Pro',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.5rem',
            letterSpacing: '0.5px',
        },
    },
});
